var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',{attrs:{"justify":"center","align":"center"}},[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","align":"center"}},[_c('ProgressLinear',[_c('h3',[_vm._v("Aguarde, carregando...")])])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }